"use client";

import { useTranslations } from "next-intl";

export function CookieSettingsTrigger() {
  const t = useTranslations()
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.Cookiebot) {
      window.Cookiebot.renew();
    }
  };

  return (
    <button type="button" onClick={handleClick} className="max-md:underline underline-offset-4">
      {t("footer.cookieSettings")}
    </button>
  );
}